<template>
  <!-- 导航栏 -->

  <div class="head" @mouseleave="rout(99)">
    <div class="heade">
      <div :class="[issho == 1 || aask == 1 ? 'headStyles' : '', 'heades']" :style="headStyle" @mouseenter="mover(2)"
        @mouseleave="mover(1)">
        <div class="header">
          <div class="headerLeft">
            <img v-if="srcs == 1" src="@/assets/img/home/logo (1).png" alt="" />
            <img v-if="srcs == 2" src="@/assets/img/home/tc72 (1).png" alt="" />
          </div>
          <div class="headerRight">
            <div class="headerRighta" @click="rout(0)" @mouseenter="rout(99)">
              <div :class="[c == 0 ? 'headerRightaspan' : '']">首页</div>
            </div>
            <div class="headerRighta" @mouseenter="rout(1)">
              <div :class="[c == 1 ? 'headerRightaspan' : '']">
                产品与服务
                <img v-show="a && srcs == 1" src="@/assets/img/home/xiala.png" alt="" />
                <img v-show="a && srcs == 2" src="@/assets/img/home/icon (21).png" alt="" />
                <img v-show="!a" src="@/assets/img/home/icon (17).png" alt="" />
              </div>
              <img v-show="!a" src="@/assets/img/home/dbx11.png" alt="" />
            </div>
            <div class="headerRighta" @mouseenter="rout(6)">
              <div :class="[c == 2 ? 'headerRightaspan' : '']">
                行业解决方案
                <img v-show="!e && srcs == 1" src="@/assets/img/home/xiala.png" alt="" />
                <img v-show="!e && srcs == 2" src="@/assets/img/home/icon (21).png" alt="" />
                <img v-show="e" src="@/assets/img/home/icon (17).png" alt="" />
              </div>
              <img v-show="e" src="@/assets/img/home/dbx11.png" alt="" />
            </div>
            <div class="headerRighta" @click="rout(2)" @mouseenter="rout(99)">
              <div :class="[c == 2 ? 'headerRightaspan' : '']">课程资源</div>
            </div>
            <div class="headerRighta" @click="rout(3)" @mouseenter="rout(99)">
              <div :class="[c == 3 ? 'headerRightaspan' : '']">招商合作</div>
            </div>
            <div class="headerRighta" @click="rout(10)" @mouseenter="rout(99)">
              <div :class="[c == 10 ? 'headerRightaspan' : '']">招生计算器</div>
            </div>
            <div class="headerRighta" @mouseenter="rout(4)">
              <div @click="routgy()" :class="[c == 4 ? 'headerRightaspan' : '']">
                关于我们
                <!-- <img
                  v-show="b && srcs == 1"
                  src="@/assets/img/home/xiala.png"
                  alt=""
                />
                <img
                  v-show="b && srcs == 2"
                  src="@/assets/img/home/icon (21).png"
                  alt=""
                />
                <img v-show="!b" src="@/assets/img/home/icon (17).png" alt="" /> -->
              </div>
              <!-- <img v-show="!b" src="@/assets/img/home/dbx11.png" alt="" /> -->
            </div>
            <!-- <div class="headerRights" :style="headStylea" @click="rout(5)">
              免费试用
            </div> -->
            <div class="Login" @click="qwLogin()">登录</div>
            <div :class="[issho == 1 || aask == 1 ? 'headStyleas' : '', 'headerRights']" :style="headStylea"
              @click="goNext(`/mfsy`)">
              免费试用
            </div>
          </div>
        </div>
      </div>
      <!--产品与服务 定位 -->
      <!-- <div
        v-show="!a"
        class="ponHeads"
        @mouseleave="rout(99)"
        @mouseenter="mover(2)"
      >
        <div @mouseleave="mover(1)">
          <span :class="[as == 0 ? 'pspana' : '']" @click="nexts(0)"
            >网校系统</span
          >
        </div>
      </div> -->
      <!--  -->

      <div v-show="!a" class="meau" @mouseleave="rout(99)" @mouseenter="mover(2)">
        <div class="mainmeau">
          <div class="shu"></div>
          <div class="shus"></div>
          <div class="shuss"></div>
          <div class="meautil">
            <div>网校平台输出</div>
            <div>垂直管理系统(MS)输出</div>
            <div>课程资源输出</div>
            <div>服务支持</div>
          </div>
          <div class="meautitle">
            <div>
              <div @click="routsk()">
                <p>多功能学习平台</p>
                <p>多终端在线网校解决方案</p>
              </div>
            </div>
            <div>
              <div @click="routs()">
                <p>教务管理系统</p>
                <p>学历教育教务管理系统</p>
              </div>
              <div @click="routs()">
                <p>积分商城系统</p>
                <p>满足积分获取积分兑换</p>
              </div>
              <div @click="routs()">
                <p>营销管理系统</p>
                <p>多重营销获客工具招生引流</p>
              </div>
              <div @click="routs()">
                <p>财务管理系统</p>
                <p>提高企业财务管理效率</p>
              </div>
              <div @click="routs()">
                <p>客户管理系统</p>
                <p>精细化用户运营促进转化</p>
              </div>
              <div @click="routs()">
                <p>售后管理系统</p>
                <p>帮助企业熟悉了解行业</p>
              </div>
            </div>
            <div>
              <div @click="routss()">
                <p>优质课程资源输出</p>
                <p>直播/录播等多种在线课程</p>
              </div>

              <div @click="routss()">
                <p>资料/题库/考场</p>
                <p>提供丰富的在线辅导课程资料</p>
              </div>
              <div @click="routss()">
                <p>自研教辅</p>
                <p>多年教辅研发经验</p>
              </div>
            </div>
            <div>
              <div @click="routsss()">
                <p>运营推广支持</p>
                <p>提供营销支持落地方案</p>
              </div>
              <div @click="routsss()">
                <p>课程销售支持</p>
                <p>辅助课程销售解决方案</p>
              </div>
              <!-- <div @click="goNext(`/jjfa`)">
                <p>教务服务支持</p>
                <p>全面打通信息化教务管理全流程</p>
              </div> -->
              <div @click="routsss()">
                <p>教务服务支持</p>
                <p>全面打通信息化教务管理全流程</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="e" class="meaus" @mouseleave="rout(99)" @mouseenter="mover(2)">
        <div class="mainmeau">
          <div class="shu"></div>
          <div class="shus"></div>
          <div class="meautil">
            <div>同行业转型升级</div>
            <div>招商合作</div>
            <div>校园合伙人</div>
          </div>
          <div class="meautitle">
            <div>
              <div @click="routjj()">
                <p>同行业升级</p>
                <p>成人教育信息化综合解决方案</p>
              </div>
            </div>

            <div>
              <div @click="routjj()">
                <p>招商合作</p>
                <p>一站式网校合作方案解决方案</p>
              </div>
            </div>
            <div>
              <div @click="routjj()">
                <p>招商校园合伙人</p>
                <p>校园招生合作综合解决方案</p>
              </div>
            </div>
            <!-- <div>
              <div>
                <p>运营推广支持</p>
                <p>提供营销支持落地方案</p>
              </div>
              <div>
                <p>课程销售支持</p>
                <p>辅助课程销售解决方案</p>
              </div>
              <div>
                <p>教务服务支持</p>
                <p>全面打通信息化教务管理全流程</p>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <!--关于我们 定位 -->
      <!-- <div
        v-show="!b"
        class="ponHead"
        @mouseleave="rout(99)"
        @mouseenter="mover(2)"
      >
        <div @mouseleave="mover(1)">
          <span :class="[bs == 0 ? 'pspana' : '']" @click="nextsa(0)"
            >公司简介</span
          >
          <span :class="[bs == 1 ? 'pspana' : '']" @click="nextsa(1)"
            >加入我们</span
          >
          <span :class="[bs == 2 ? 'pspana' : '']" @click="nextsa(2)"
            >新闻动态</span
          >
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { qrConnect } from '@/api/login.js'
/* eslint-disable */
export default {
  props: ['issho', 'aask'],
  data () {
    return {
      a: true, // 产品与服务 展开收起三角
      as: '', // 产品与服务 选中颜色
      b: true, // 关于我们 展开收起三角
      bs: '', // 关于我们 选中颜色
      c: 99,
      e: false,
      cssnew: true,
      // 导航栏样式
      headStyle: {
        background: 'none',
        color: 'rgba(255, 255, 255, 1)',
      },
      headStylea: {
        background: 'rgba(255, 255, 255, 1)',
        color: 'rgba(32,104,255, 1)',
      },
      srcs: 1,
      colors: false,
    }
  },
  created () {
    this.as = this.$route.query.inde
    this.bs = this.$route.query.inde
    console.log(this.aask, 'this.srcs1')
    this.$nextTick(() => {
      if (this.issho == 1 || this.aask == 1) {
        this.srcs = 2
        this.cssnew = false
        this.headStyle.background = 'rgba(255, 255, 255, 1) !important'
        this.headStyle.color = 'rgba(0, 0, 0, 1) !important'
        this.headStylea.background = `rgba(32,104,255, 1) !important`
        this.headStylea.color = `rgba(255,255,255, 1) !important`
      }
    })

    console.log(this.srcs, 'this.srcs2')
  },
  mounted () {
    if (this.issho == 1 || this.aask == 1) {
      this.srcs = 2
      this.cssnew = false
      this.headStyle.background = 'rgba(255, 255, 255, 1) !important'
      this.headStyle.color = 'rgba(0, 0, 0, 1) !important'
      this.headStylea.background = `rgba(32,104,255, 1) !important`
      this.headStylea.color = `rgba(255,255,255, 1) !important`
    }
    window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    routs () {
      console.log(this.$route.path == '/sys')
      if (this.$route.path == '/sys') {
        this.$emit('aaa', 1)
        console.log(this.$route.path == '/sys', '=====================')
      } else {
        this.$router.push({ path: '/sys' })
      }
      // this.$router.push({ path: '/' })
    },
    routss () {
      this.$router.push({ path: '/cooperation' })
    },
    routsss () {
      this.$router.push({ path: '/zcfw' })
    },
    routsk () {
      this.$router.push({ path: '/dgnstyle' })
    },
    routgy () {
      this.$router.push({ path: '/aboutIntroduce' })
    },
    routjj () {
      if (this.$route.path == '/jjfa') {
        this.$emit('aaa', 1)
        // console.log(this.$route.path == '/sys', '=====================')
      } else {
        this.$router.push({ path: '/jjfa' })
      }
    },
    mover (index) {
      if (this.issho == 1 || this.aask == 1) {
        this.srcs = 2
      } else {
        this.srcs = index
        if (index === 2) {
          this.headStyle.background = 'rgba(255, 255, 255, 1)'
          this.headStyle.color = 'rgba(0, 0, 0, 1)'
          this.headStylea.background = `rgba(32,104,255, 1)`
          this.headStylea.color = `rgba(255,255,255, 1)`
        } else {
          this.headStyle.background = 'none'
          this.headStyle.color = '#FFFFFF'
          this.headStylea.background = `rgba(255, 255, 255, 1)`
          this.headStylea.color = `rgba(32,104,255, 1)`
        }
      }
    },
    // 导航栏页面跳转
    rout (index) {
      this.c = index
      if (index === 0) {
        this.$router.push({ path: '/' })
      } else if (index === 1) {
        this.a = !this.a
        this.e = false
        this.c = 1
        // this.as=0
        if (this.b === false) {
          this.b = true
          // this.bs=0
        }
      } else if (index === 2) {
        this.$router.push({ path: '/curriculum' })
      } else if (index === 3) {
        this.$router.push({ path: '/cooperation' })
      } else if (index === 4) {
        this.b = !this.b
        this.c = 4
        // this.bs=0
        if (this.a === false) {
          this.a = true
          // this.as=0
        }
      } else if (index === 5) {
        this.$router.push({ path: '/productSystems', query: { inde: index } })
      } else if (index === 6) {
        this.a = true
        this.e = true
      } else if (index === 10) {
        this.$router.push({ path: '/zscomputer', query: { inde: index } })
      } else if (index === 99) {
        this.a = true
        this.b = true
        this.e = false
        this.c = 99
      }
    },
    // 产品与服务 展开选中颜色
    nexts (index) {
      this.as = index
      if (index === 0) {
        // 网校系统
        this.$router.push({ path: '/productSystem', query: { inde: index } })
      }
    },
    // 关于我们 展开选中颜色
    nextsa (index) {
      this.bs = index
      if (index === 0) {
        // 加入我们
        this.$router.push({ path: '/aboutIntroduce', query: { inde: index } })
      } else if (index === 1) {
        // 加入我们
        this.$router.push({ path: '/aboutJoin', query: { inde: index } })
      } else if (index === 2) {
        this.$router.push({ path: '/aboutNew', query: { inde: index } })
      }
    },
    handleScroll () {
      if (this.issho == 1 || this.aask == 1) {
      } else {
        var yheight1 = window.pageYOffset
        if (yheight1 == 0) {
          this.cssnew = true
          this.srcs = 1
          this.headStyle.background = 'none'
          this.headStyle.color = '#FFFFFF'
          this.headStylea.background = `rgba(255, 255, 255, 1)`
          this.headStylea.color = `rgba(32,104,255, 1)`
        } else {
          this.srcs = 2
          this.cssnew = false
          this.headStyle.background = 'rgba(255, 255, 255, 1)'
          this.headStyle.color = 'rgba(0, 0, 0, 1)'
          this.headStylea.background = `rgba(32,104,255, 1)`
          this.headStylea.color = `rgba(255,255,255, 1)`
        }
      }
    },
    qwLogin () {
      qrConnect({ type: 2 }).then((res) => {
        if (res.data.connect_url) {
          window.open(res.data.connect_url, '_blank')
        }
      })
    },

    // 页面移动导航栏改变颜色
  },
}
</script>
<style lang="less" scoped>
// 导航栏
.head {
  width: 100%;
  height: auto;
  // background: rgba(0, 0, 0, 0.2);
  // background: rgba(0, 0, 0, 0.2) none repeat scroll 0 0 !important;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  color: #fff;
  // color: #ffffff;
  // 缩宽
  .heade {
    width: 100%;
    height: auto;
    position: relative;

    .heades {
      position: relative;
      width: 100%;
      height: auto;
      // box-shadow: 0px 3px 7px rgba(153, 153, 153, 0.2);
      .header {
        width: 1200px;
        height: 68px;
        // margin: 0 360px;
        margin: 0 auto;
        display: flex;
        // justify-content: space-between;
        align-items: center;
        // 左侧logo
        .headerLeft {
          width: 108px;
          height: 36px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        // 右侧导航栏内容
        .headerRight {
          width: auto;
          height: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-left: 92px;
          // 内容
          .headerRighta {
            width: auto;
            height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
            cursor: pointer;
            // color: #fff;
            div {
              width: auto;
              height: 21px;
              margin-top: 25px;
              display: flex;
              justify-content: center;
              // align-items: center;
              font-size: 16px;
              // color: #FFFFFF;
              font-family: Microsoft YaHei;
              font-weight: 400;
              margin-left: 30px;
              img {
                width: 8px;
                height: 4.8px;
                margin-left: 4px;
                margin-top: 10px;
              }
            }
            div:hover {
              color: #2068ff;
            }
            .headerRightaspan {
              color: #2068ff;
            }
            img {
              width: 11px;
              height: 6px;
              margin-top: 15px;
              margin-left: 40px;
            }
          }
          // 右侧导航栏按钮免费试用
          .headerRights {
            width: 100px;
            height: 36px;
            border-radius: 18px;
            background: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 40px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #2068ff;
            cursor: pointer;
            // margin-left: 114px;
          }
        }
      }
    }
    .ponHead {
      width: 140px;
      height: 140px;
      position: absolute;
      top: 67px;
      right: 480px;
      background: #ffffff;
      opacity: 1;
      border-radius: 0px 0px 4px 4px;
      div {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        span {
          width: auto;
          height: 19px;
          margin-top: 20px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #222222;
          opacity: 1;
          cursor: pointer;
        }
        .pspana {
          color: #2068ff;
        }
      }
    }
    .ponHeads {
      width: 140px;
      // height: 140px;
      height: auto;
      position: absolute;
      top: 67px;
      right: 800px;
      background: #ffffff;
      opacity: 1;
      border-radius: 0px 0px 4px 4px;
      div {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        span {
          width: auto;
          height: 19px;
          margin-top: 20px;
          margin-bottom: 20px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #222222;
          opacity: 1;
          cursor: pointer;
        }
        .pspana {
          color: #2068ff;
        }
      }
    }
  }
}
.meau {
  width: 100%;
  height: 300px;
  background-color: #fff;

  .mainmeau {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    .shu {
      position: absolute;
      // left: 363px;
      width: 228px;
      height: 100%;
      border-right: 2px solid;
      border-image: -webkit-linear-gradient(
          -180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(237, 240, 245),
          rgba(255, 255, 255, 0) 99%
        )
        2 2 2 2;
      border-image: -moz-linear-gradient(
          -180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(237, 240, 245),
          rgba(255, 255, 255, 0) 99%
        )
        2 2 2 2;
      border-image: linear-gradient(
          -180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(237, 240, 245),
          rgba(255, 255, 255, 0) 99%
        )
        2 2 2 2;
    }
    .shus {
      position: absolute;
      width: 666px;
      height: 100%;
      border-right: 2px solid;
      border-image: -webkit-linear-gradient(
          -180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(237, 240, 245),
          rgba(255, 255, 255, 0) 99%
        )
        2 2 2 2;
      border-image: -moz-linear-gradient(
          -180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(237, 240, 245),
          rgba(255, 255, 255, 0) 99%
        )
        2 2 2 2;
      border-image: linear-gradient(
          -180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(237, 240, 245),
          rgba(255, 255, 255, 0) 99%
        )
        2 2 2 2;
    }
    .shuss {
      position: absolute;
      width: 932px;
      height: 100%;
      border-right: 2px solid;
      border-image: -webkit-linear-gradient(
          -180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(237, 240, 245),
          rgba(255, 255, 255, 0) 99%
        )
        2 2 2 2;
      border-image: -moz-linear-gradient(
          -180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(237, 240, 245),
          rgba(255, 255, 255, 0) 99%
        )
        2 2 2 2;
      border-image: linear-gradient(
          -180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(237, 240, 245),
          rgba(255, 255, 255, 0) 99%
        )
        2 2 2 2;
    }
    .meautil {
      position: relative;
      width: 100%;
      padding: 23px 0;
      display: flex;
      justify-content: space-around;
      > div {
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #006de7;
        line-height: 21px;
        text-align: center;
      }
      > div:nth-child(1) {
        width: 196px;
      }
      > div:nth-child(2) {
        width: 390px;
      }
      > div:nth-child(3) {
        width: 247px;
      }
      > div:nth-child(4) {
        width: 230px;
      }
    }
    .meautitle {
      position: relative;
      width: 100%;
      height: 190px;
      // background-color: red;
      display: flex;
      > div {
        margin: 0 auto;
        // margin-left: 30px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        > div {
          width: 188px;
          height: 54px;
          background: #f1f2fd;
          border-radius: 4px;
          padding-left: 11px;
          padding-top: 8px;
          padding-right: 9px;
          padding-bottom: 7px;
          margin-right: 5px;
          text-align: center;
          cursor: pointer;
          p:nth-child(1) {
            font-size: 15px;
            font-family: Microsoft YaHei;
            font-weight: 300;

            color: #000000;
          }
          p:nth-child(2) {
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: #9aa1ab;
            margin-top: 4px;
          }
        }
        // > div:hover {
        //   background: url('~@/assets/tt1.png');
        //   background-repeat: no-repeat;
        // }
      }
      > div:nth-child(1) {
        width: 196px;
        // > div {
        //   width: 172px;
        //   height: 60px;
        //   background: url('~@/assets/tt1.png');
        //   background-repeat: no-repeat;
        //   padding-left: 11px;
        //   padding-top: 11px;
        //   p:nth-child(1) {
        //     font-size: 15px;
        //     font-family: Microsoft YaHei;
        //     font-weight: 300;
        //     color: #2c7cff;
        //   }
        //   p:nth-child(2) {
        //     font-size: 12px;
        //     font-family: Microsoft YaHei;
        //     font-weight: 300;
        //     color: #9aa1ab;
        //     margin-top: 5px;
        //   }
        // }
      }
      > div:nth-child(2) {
        width: 390px;
      }
      > div:nth-child(3) {
        width: 247px;
      }
      > div:nth-child(4) {
        width: 230px;
      }
    }
  }
}
.meaus {
  width: 100%;
  height: 270px;
  background-color: #fff;
  .mainmeau {
    position: relative;
    width: 750px;
    margin: 0 auto;
    .shu {
      position: absolute;
      // left: 363px;
      width: 250px;
      height: 100%;
      border-right: 2px solid;
      border-image: -webkit-linear-gradient(
          -180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(237, 240, 245),
          rgba(255, 255, 255, 0) 99%
        )
        2 2 2 2;
      border-image: -moz-linear-gradient(
          -180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(237, 240, 245),
          rgba(255, 255, 255, 0) 99%
        )
        2 2 2 2;
      border-image: linear-gradient(
          -180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(237, 240, 245),
          rgba(255, 255, 255, 0) 99%
        )
        2 2 2 2;
    }
    .shus {
      position: absolute;
      // left: 363px;
      width: 500px;
      height: 100%;
      border-right: 2px solid;
      border-image: -webkit-linear-gradient(
          -180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(237, 240, 245),
          rgba(255, 255, 255, 0) 99%
        )
        2 2 2 2;
      border-image: -moz-linear-gradient(
          -180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(237, 240, 245),
          rgba(255, 255, 255, 0) 99%
        )
        2 2 2 2;
      border-image: linear-gradient(
          -180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(237, 240, 245),
          rgba(255, 255, 255, 0) 99%
        )
        2 2 2 2;
    }
    .meautil {
      position: relative;
      width: 100%;
      padding: 23px 0;
      display: flex;
      justify-content: space-around;
      > div {
        width: 33%;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #006de7;
        line-height: 21px;
        text-align: center;
      }
      // > div:nth-child(1) {
      //   width: 236px;
      // }
      // > div:nth-child(2) {
      //   width: 284px;
      // }
    }
    .meautitle {
      position: relative;
      width: 100%;
      height: 190px;
      // background-color: red;
      display: flex;
      > div {
        width: 33%;
        margin: 0 auto;
        // margin-left: 30px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        > div {
          width: 188px;
          height: 54px;
          background: #f1f2fd;
          border-radius: 4px;
          padding-left: 11px;
          padding-top: 8px;
          padding-right: 9px;
          padding-bottom: 7px;
          margin-right: 5px;
          text-align: center;
          cursor: pointer;
          p:nth-child(1) {
            font-size: 15px;
            font-family: Microsoft YaHei;
            font-weight: 300;

            color: #000000;
          }
          p:nth-child(2) {
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: #9aa1ab;
            margin-top: 4px;
          }
        }
        // > div:hover {
        //   background: url('~@/assets/tt1.png');
        //   background-repeat: no-repeat;
        // }
      }
      > div:nth-child(1) {
        // width: 236px;
        // > div {
        //   width: 172px;
        //   height: 60px;
        //   background: url('~@/assets/tt1.png');
        //   background-repeat: no-repeat;
        //   padding-left: 11px;
        //   padding-top: 11px;
        //   p:nth-child(1) {
        //     font-size: 15px;
        //     font-family: Microsoft YaHei;
        //     font-weight: 300;
        //     color: #2c7cff;
        //   }
        //   p:nth-child(2) {
        //     font-size: 12px;
        //     font-family: Microsoft YaHei;
        //     font-weight: 300;
        //     color: #9aa1ab;
        //     margin-top: 5px;
        //   }
        // }
      }
      > div:nth-child(2) {
        // width: 284px;
      }
    }
  }
}
.headStyles {
  background: rgba(255, 255, 255, 1) !important;
  color: rgba(0, 0, 0, 1) !important;
}
.headStyleas {
  background: rgba(32, 104, 255, 1) !important;
  color: rgba(255, 255, 255, 1) !important;
}
.Login {
  margin-left: 114px;
  cursor: pointer;
}
</style>
